import { Module } from 'wrapper6'

const $ = jQuery

export default class ReadMore extends Module {
  ready (app) {
    this.onReadMoreClick()
  }

  onReadMoreClick () {
    const buttons = document.querySelectorAll('.mtt-read-more__btn')

    if (buttons) {
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i]

        button.addEventListener('click', () => {
          this.overFold = button.previousElementSibling.previousElementSibling
          this.underFold = button.previousElementSibling
          this.openText = button.getAttribute('data-open')
          this.closeText = button.getAttribute('data-close')

          if (this.overFold && this.underFold) {
            this.underFold.classList.toggle('show')

            this.toggleButtonText(button)
          }
        })
      }
    }
  }

  toggleButtonText (button) {
    const tabs = document.querySelector('.sticky.is-sticky')
    let offset = 160

    if (tabs) {
      offset = offset + tabs.offsetHeight
    }

    if (this.underFold.classList.contains('show')) {
      if (this.closeText) {
        button.innerHTML = this.closeText
      }

      button.classList.add('opened')
    } else {
      if (this.openText) {
        button.innerHTML = this.openText
      }

      button.classList.remove('opened')

      $([document.documentElement, document.body]).animate({
        scrollTop: $(this.overFold).offset().top - offset
      }, 500)
    }
  }
}
